const BASE_API_URL = "https://exun-api.herokuapp.com/api";
export default BASE_API_URL;
